import { c as _c } from "react/compiler-runtime";
import { Card, Divider } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useBuilderNavigation from '../../hooks/use-builder-navigation';
import { useBuilder } from '../../store/provider';
import { isTaskNode } from '../../store/types';
import SkillSummary from '../skills-view/skill-summary';
import { getMentionedSkills, getSkillEntry } from '../skills-view/skill-tree';
import { SectionHeading } from './primitives';
type TaskSkillsProps = {
  nodeId: string;
};
const TaskSkills = t0 => {
  const $ = _c(42);
  const {
    nodeId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.task.skills"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    state,
    actions
  } = useBuilder();
  const {
    setViewMode
  } = useBuilderNavigation();
  const {
    nodes,
    skills
  } = state.bundle;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== actions || $[2] !== nodeId || $[3] !== nodes || $[4] !== setViewMode || $[5] !== skills || $[6] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const tasks = nodes.filter(isTaskNode);
      let t7;
      if ($[14] !== nodeId) {
        t7 = candidate => candidate.id === nodeId;
        $[14] = nodeId;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      const task = tasks.find(t7);
      if (!task) {
        t6 = null;
        break bb0;
      }
      let t8;
      if ($[16] !== skills) {
        t8 = candidate_0 => getMentionedSkills(candidate_0, skills);
        $[16] = skills;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      const mentions = tasks.map(t8);
      const mentioned = getMentionedSkills(task, skills);
      const used = skills.flatMap((node, index) => mentioned.has(node.name) ? [{
        node,
        path: String(index)
      }] : []);
      if (used.length === 0) {
        t6 = null;
        break bb0;
      }
      let t9;
      if ($[18] !== actions || $[19] !== setViewMode) {
        t9 = (node_0, path) => {
          actions.skills.select(getSkillEntry(node_0, path)?.path ?? path);
          setViewMode("skills");
        };
        $[18] = actions;
        $[19] = setViewMode;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      const open = t9;
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <Divider />;
        $[21] = t5;
      } else {
        t5 = $[21];
      }
      T1 = Card.Root;
      let t10;
      if ($[22] !== t) {
        t10 = t(_temp);
        $[22] = t;
        $[23] = t10;
      } else {
        t10 = $[23];
      }
      let t11;
      if ($[24] !== t) {
        t11 = t(_temp2);
        $[24] = t;
        $[25] = t11;
      } else {
        t11 = $[25];
      }
      if ($[26] !== t10 || $[27] !== t11) {
        t4 = <SectionHeading hint={t10} title={t11} />;
        $[26] = t10;
        $[27] = t11;
        $[28] = t4;
      } else {
        t4 = $[28];
      }
      T0 = Card.List;
      if ($[29] !== t) {
        t2 = t(_temp3);
        $[29] = t;
        $[30] = t2;
      } else {
        t2 = $[30];
      }
      t3 = used.map(t12 => {
        const {
          node: node_1,
          path: path_0
        } = t12;
        return <Card.Body as="li" key={path_0} className="p-0 hover:bg-hover focus-within:bg-hover"><button type="button" onClick={() => open(node_1, path_0)} className="flex w-full items-start gap-3 rounded-default px-4 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent"><SkillSummary node={node_1} path={path_0} usedBy={mentions.filter(candidate_1 => candidate_1.has(node_1.name)).length} /></button></Card.Body>;
      });
    }
    $[1] = actions;
    $[2] = nodeId;
    $[3] = nodes;
    $[4] = setViewMode;
    $[5] = skills;
    $[6] = t;
    $[7] = T0;
    $[8] = T1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    T0 = $[7];
    T1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[31] !== T0 || $[32] !== t2 || $[33] !== t3) {
    t7 = <T0 aria-label={t2}>{t3}</T0>;
    $[31] = T0;
    $[32] = t2;
    $[33] = t3;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== T1 || $[36] !== t4 || $[37] !== t7) {
    t8 = <T1>{t4}{t7}</T1>;
    $[35] = T1;
    $[36] = t4;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== t5 || $[40] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[39] = t5;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};
export default TaskSkills;
function _temp($) {
  return $.hint;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.title;
}